import { FetchPdfium } from "../../files/FetchPdfium"
import { GenerateFile } from "../../files/GenerateFile"
import { RectangleFromArray } from "../../geometry/RectangleFromArray"
import type { PdfEngine } from "../../types/engine/PdfEngine"
import { ContentType } from "../../types/files/ContentType"
import { VirtualFileType } from "../../types/files/VirtualFileType"
import type { TaskResult } from "../../types/tasks/input/TaskResult"
import type { TaskRasterizeOptions } from "../../types/tasks/options/TaskRasterizeOptions"
import { TaskName } from "../../types/tasks/TaskName"
import { TrackedTaskName } from "../../types/tasks/tracking/TrackedTaskName"
import type { TrackingCallback } from "../../types/tasks/tracking/TrackingCallback"

// options RasterizePdfOptions - file: GeneratedFile
// stream no
// emit TrackingCallback
//
// return DocumentPage[1, GeneratedFile[...]]

export async function* TaskRasterize(
  engine: PdfEngine,
  task: TaskRasterizeOptions,
  emit: TrackingCallback
): AsyncGenerator<TaskResult> {
  const { page_count, iterate_pages, rasterize, close } = await FetchPdfium(
    engine,
    task.options,
    task.source,
    emit
  )

  try {
    // Update progress if multi-page
    //
    void emit({
      name: TrackedTaskName.RASTERIZE_PDF,
      done: 0,
      total: page_count,
    })

    // Render each page
    for await (const page_number of iterate_pages()) {
      const { blob, size } = await rasterize(page_number)

      const content = await GenerateFile(engine, [blob], ContentType.PNG)

      yield {
        enum: TaskName.CONTENT_FILE,
        name: `${page_number}.png`,
        content: {
          enum: VirtualFileType.SINGLE_PAGE_IMAGE,
          source: task.source,
          content,
          file_meta: {},
          size: RectangleFromArray(task.options, size),
        },
      }
      void emit({
        name: TrackedTaskName.RASTERIZE_PDF,
        done: page_number,
        total: page_count,
      })
    }
  } finally {
    // Clean up document and release lock
    await close()
  }
}
